let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("59sjH")).then(() => parcelRequire('le0cr'));